import {useTranslation} from '@aboutyou/i18n';
import {useTrackFeatureInViewImpression} from '@aboutyou/tracking';
import {
  Button,
  EmptyState,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  mediaDesktopAndUp,
  mediaLargeScreens,
  mobileOnly,
  tabletAndUp,
  Text,
} from '@aboutyou/ui-components';
import {styled as linariaStyled} from '@linaria/react';
import React, {RefObject} from 'react';
import sc, {css} from 'styled-components';
import {GoBackView} from '../../../features/GoBackView/GoBackView';
import {useAdpLink} from '../hooks/useAdpLink';

export const SimilarProductsEmpty: React.FC = () => {
  const {t} = useTranslation();
  const link = useAdpLink();
  const {ref} = useTrackFeatureInViewImpression({
    label: 'similar_products_empty',
  });

  return (
    <Center>
      <EmptyState
        ref={ref as RefObject<HTMLDivElement | null>}
        title={
          <StyledHeading as="h1">{t('Nothing was found...')}</StyledHeading>
        }
        subtitle={t(
          "We're sorry! There are currently no recommendations for this product.",
        )}
        data-testid="SimilarProductsEmpty"
        asset={<IconWrapper asset={GenericIconName.EmptySearch} />}
        cta={
          <GoBackView
            View={({onClick}) => {
              return (
                <Button
                  variant="secondary"
                  data-testid="SimilarProductsGoBackButton"
                  onClick={onClick}
                >
                  {t('Go back')}
                </Button>
              );
            }}
            backLinkTarget={{url: link, external: false}}
          />
        }
      />
    </Center>
  );
};

const IconWrapper = linariaStyled(Icon)`
  width: 150px;
  height: 210px;
`;

const StyledHeading = sc(Text)`
  font-weight: ${FONT_WEIGHTS.bold};
  font-size: ${FONT_SIZES.px20};

  ${tabletAndUp(css`
    font-size: ${FONT_SIZES.px24};
  `)}
`;

const Center = sc.li`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-top: 50px;
  ${mobileOnly(
    css`
      margin-top: 25px;
    `,
  )}
  grid-column: span 2;

  @media ${mediaDesktopAndUp} {
    grid-column: span 3;
  }

  @media ${mediaLargeScreens} {
    grid-column: span 4;
  }
`;
